module.exports = __webpack_public_path__ + "img/g2.49af8971.png";